import { render, staticRenderFns } from "./Wtjd.vue?vue&type=template&id=74ca013a&scoped=true&"
import script from "./Wtjd.vue?vue&type=script&lang=js&"
export * from "./Wtjd.vue?vue&type=script&lang=js&"
import style0 from "./Wtjd.vue?vue&type=style&index=0&id=74ca013a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ca013a",
  null
  
)

export default component.exports